import {
  Button,
  Flex,
  Icon,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
} from "@chakra-ui/react";
import React from "react";
import { Field, Form } from "react-final-form";
import InputField from "../../../fields/InputField";
import NumberField from "../../../fields/NumberField";
import SelectField from "../../../fields/SelectField";
import { createMassCommoditiesValidator as validate } from "./validators";
import { BsFillInfoCircleFill } from "react-icons/bs";
import { FieldArray } from "react-final-form-arrays";
import arrayMutators from "final-form-arrays";
import { AddIcon, MinusIcon } from "@chakra-ui/icons";
import { PRODUCT_CATEGORIES, UNITS } from "../../../../utils/constants";
import MeasurementUnitField from "../../../fields/MeasurementUnitField";
import CategoriesField from "../../../fields/CategoriesField";

type Props = {
  onSubmit: (...params: any) => void;
  formName?: string;
  initialValues?: any;
};

const CreateMassCommodityForm = (props: Props) => {
  const { onSubmit, formName, initialValues } = props;
  return (
    <Form
      onSubmit={onSubmit}
      validate={validate}
      mutators={{ ...arrayMutators }}
      initialValues={initialValues}
    >
      {({
        handleSubmit,
        form: {
          mutators: { push, pop }, // injected from final-form-arrays above
        },
      }) => (
        <form onSubmit={handleSubmit} id={formName}>
          <TableContainer>
            <Table variant="simple">
              <Thead>
                <Tr>
                  <Th>Name</Th>
                  <Th>Categories</Th>

                  <Th cursor="pointer">
                    <Tooltip label="Unit of Measurement">
                      <Flex display="flex" alignItems="center">
                        <Text mr="1">Measurement Unit</Text>{" "}
                        <BsFillInfoCircleFill />
                      </Flex>
                    </Tooltip>
                  </Th>
                  <Th>Retail</Th>
                  <Th>Whole Sale</Th>
                  <Th></Th>
                </Tr>
              </Thead>
              <Tbody>
                <FieldArray name="commodities">
                  {({ fields }) =>
                    fields.map((name, index) => (
                      <Tr key={name}>
                        <Td>
                          <Field name={`${name}.name`} component={InputField} />
                        </Td>
                        <Td>
                          <Field
                            name={`${name}.categories`}
                            component={CategoriesField}
                            options={PRODUCT_CATEGORIES}
                            menuPortalTarget={document.body}
                          />
                        </Td>

                        <Td>
                          <Field
                            name={`${name}.measurementUnit`}
                            component={MeasurementUnitField}
                            menuPortalTarget={document.body}
                            options={UNITS}
                          />
                        </Td>
                        <Td>
                          <Field
                            name={`${name}.retail`}
                            min={1}
                            component={NumberField}
                          />
                        </Td>
                        <Td>
                          <Field
                            name={`${name}.wholeSale`}
                            min={0}
                            component={NumberField}
                          />
                        </Td>
                        <Td>
                          <Button
                            mr="3"
                            onClick={() => pop("commodities", undefined)}
                          >
                            <Icon as={MinusIcon} />
                          </Button>
                        </Td>
                      </Tr>
                    ))
                  }
                </FieldArray>
              </Tbody>
            </Table>
            <Flex p="6" justifyContent="end">
              <Button mr="3" onClick={() => push("commodities", undefined)}>
                <Icon as={AddIcon} />
              </Button>
            </Flex>
          </TableContainer>
        </form>
      )}
    </Form>
  );
};

export default CreateMassCommodityForm;
